module.exports = __webpack_public_path__ + "static/Routines_Menu1-011cc4d4bee5a79c6cab83666ec89235.png";